(function () {
  'use strict';

  angular.module('sempraWebapp').service('tapWaterSubsystemUtils', tapWaterSubsystemUtilsService);

  /** @ngInject */
  function tapWaterSubsystemUtilsService (modelUtils, PointTypeEnum) {
    var that = this;

    this.getTapWaterSubsystemPoint = function (facilityJson) {
      return facilityJson.points.find(function (pointJson) {
        return pointJson.pointType === PointTypeEnum.SUBSYSTEM
          && pointJson.name === PointTypeEnum.properties.NAMES.TAP_WATER;
      });
    };

    this.getFeedValue = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getValue(pointJson);
    };

    this.getFeed = function (pointJson, feedReference) {
      return that.FeedReferences.properties[feedReference].getFeed(pointJson);
    };

    this.getActuatorValue = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getValue(pointJson);
    };

    this.getActuator = function (pointJson, actuatorReference) {
      return that.ActuatorReferences.properties[actuatorReference].getActuator(pointJson);
    };

    this.FeedReferences = Object.freeze({
      OP_MIN_NIVO_PITKA_VODA: 'OP_MIN_NIVO_PITKA_VODA',
      OP_CRPKA_PITKE_VODE_GRE_MZS: 'OP_CRPKA_PITKE_VODE_GRE_MZS',
      OP_MAX_NIVO_PITKA_VODA: 'OP_MAX_NIVO_PITKA_VODA',
      OP_TLAK_PITKA_VODA: 'OP_TLAK_PITKA_VODA',
      OP_CRPKA_PITKE_VODE_RAD: 'OP_CRPKA_PITKE_VODE_RAD',
      OP_EMV_SPR_PITKA_VODA: 'OP_EMV_SPR_PITKA_VODA',
      OP_BUTTON_6M6_BR_RESET: 'OP_BUTTON_6M6_BR_RESET',
      OP_CPV_6M6_BROJ_SATI_RADA: 'OP_CPV_6M6_BROJ_SATI_RADA',
      properties: {
        OP_MIN_NIVO_PITKA_VODA: getFeedPropertiesObject('OP_MIN_NIVO_PITKA_VODA'),
        OP_CRPKA_PITKE_VODE_GRE_MZS: getFeedPropertiesObject('OP_CRPKA_PITKE_VODE_GRE_MZS'),
        OP_MAX_NIVO_PITKA_VODA: getFeedPropertiesObject('OP_MAX_NIVO_PITKA_VODA'),
        OP_TLAK_PITKA_VODA: getFeedPropertiesObject('OP_TLAK_PITKA_VODA'),
        OP_CRPKA_PITKE_VODE_RAD: getFeedPropertiesObject('OP_CRPKA_PITKE_VODE_RAD'),
        OP_EMV_SPR_PITKA_VODA: getFeedPropertiesObject('OP_EMV_SPR_PITKA_VODA'),
        OP_BUTTON_6M6_BR_RESET: getFeedPropertiesObject('OP_BUTTON_6M6_BR_RESET'),
        OP_CPV_6M6_BROJ_SATI_RADA: getFeedPropertiesObject('OP_CPV_6M6_BROJ_SATI_RADA')
      }
    });

    this.ActuatorReferences = Object.freeze({

    });

    function getFeedPropertiesObject (feedReference) {
      return {
        getValue: function (facilityPointJson) {
          return modelUtils.getFeedCurrentValue(facilityPointJson, feedReference);
        },
        getFeed: function (facilityPointJson) {
          return modelUtils.getFeed(facilityPointJson, feedReference);
        }
      }
    }
    //
    //function getActuatorPropertiesObject (actuatorReference) {
    //  return {
    //    getValue: function (facilityPointJson) {
    //      return modelUtils.getActuatorCurrentValue(facilityPointJson, actuatorReference);
    //    },
    //    getActuator: function (facilityPointJson) {
    //      return modelUtils.getActuator(facilityPointJson, actuatorReference);
    //    }
    //  }
    //}
  }
})();
